import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=15509c3f&"
import script from "./LoginButton.vue?vue&type=script&lang=js&"
export * from "./LoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports